module.exports = {
      id: "charging-usage",
      viewBox: "0 0 36 24",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#charging-usage",
      toString: function () {
        return this.url;
      }
    }